import { h } from "preact";

import { classNames, renderIcon } from "../helpers";

export default function Alert({ children, ...PushSubscriptionOptions }) {
  const classes = classNames(
    "alert",
    PushSubscriptionOptions.error ? "alert--error" : "alert--info",
    PushSubscriptionOptions.class
  );
  let icon = "info";
  if (PushSubscriptionOptions.error) {
    icon = "warning";
  }

  return (
    <div class={classes}>
      {renderIcon(icon, "alert__icon")}
      {children}
    </div>
  );
}
